<div *ngIf="imageZoom && version !== 'none' && version !== '2' && version !== '3'" class="image-input">
  <ng-template #popTemplate1>
    <img class="default-image" [src]="imageUrl"/>
  </ng-template>

  <div class="zf-form-image"
       [popover]="popTemplate1"
       containerClass="custom-popover1"
       placement="right"
       triggers="mouseenter:mouseleave">
    <img [src]="imageUrl"/>
  </div>
</div>

<div class="zf-s3-upload-image">
  <p *ngIf="errorMsg" class="text-danger">{{ errorMsg }}</p>

  <!-- <object type="image/svg+xml" data="https://s3.amazonaws.com/clients.mango.config/ccf/accreditation/82670668_kiwi.svg"></object> -->
  <!-- <embed type="image/svg+xml" src="https://s3.amazonaws.com/clients.mango.config/ccf/accreditation/82670668_kiwi.svg"> -->
  <!-- <iframe src="https://s3.amazonaws.com/clients.mango.config/ccf/accreditation/82670668_kiwi.svg" width="370" height="370"></!-->

  <div *ngIf="version === '1'" class="version1">
    <label for="file-upload-{{ token }}" class="custom-file-upload" [ngClass]="{ 'disabled-btn': isUploaded }">
      <i *ngIf="!isUploaded" class="fa fa-cloud-upload"></i> Upload
      <i *ngIf="isUploaded" class="fa fa-circle-o-notch fa-spin"></i>
    </label>
    <input id="file-upload-{{ token }}" type="file" (change)="selectFile($event)"/>
  </div>

  <div *ngIf="!version">
    <label class="btn btn-default">
      <input type="file" (change)="selectFile($event)">
      <i *ngIf="isUploaded" class="fa fa-circle-o-notch fa-spin"></i>
    </label>
  </div>

  <!--  https://stackblitz.com/edit/angular-drag-n-drop-directive?file=src%2Fapp%2Fapp.component.html-->
  <ng-container *ngIf="version === '2'">
    <div class="container_multiple">
      <input type="file" multiple (change)="selectFileMultiples($event)"/>
      <svg xmlns="http://www.w3.org/2000/svg" width="63" height="64" viewBox="0 0 63 64">
        <g fill="#3B454F" fill-rule="nonzero">
          <path
            d="M42.656 15.135a1.953 1.953 0 0 1-1.391-.578L31.5 4.795l-9.765 9.762a1.97 1.97 0 1 1-2.785-2.785L30.106.616a1.97 1.97 0 0 1 2.785 0l11.157 11.156a1.97 1.97 0 0 1-1.392 3.363z"/>
          <path
            d="M31.5 36.791a1.97 1.97 0 0 1-1.969-1.969V2.01a1.97 1.97 0 0 1 3.938 0v32.812a1.97 1.97 0 0 1-1.969 1.969z"/>
          <path
            d="M55.781 63.041H7.22A7.225 7.225 0 0 1 0 55.822V41.385a4.599 4.599 0 0 1 4.594-4.594h7.234a4.567 4.567 0 0 1 4.402 3.276l2.814 9.382a.658.658 0 0 0 .628.467h23.656a.658.658 0 0 0 .628-.467l2.814-9.385a4.572 4.572 0 0 1 4.402-3.273h7.234A4.599 4.599 0 0 1 63 41.385v14.437a7.225 7.225 0 0 1-7.219 7.219zM4.594 40.729a.656.656 0 0 0-.657.656v14.437a3.286 3.286 0 0 0 3.282 3.282H55.78a3.286 3.286 0 0 0 3.282-3.282V41.385a.656.656 0 0 0-.657-.656h-7.234a.65.65 0 0 0-.628.467L47.73 50.58a4.628 4.628 0 0 1-4.402 3.274H19.672a4.567 4.567 0 0 1-4.402-3.276l-2.814-9.382a.65.65 0 0 0-.628-.467H4.594z"/>
        </g>
      </svg>

      <h5>Drag and drop file here or Browse</h5>
      <!--      <h5>or</h5>-->
      <!--      <label>Browse for file</label>-->
    </div>

    <div class="files-list">
      <div class="single-file" *ngFor="let item of files; let i = index">
        <zf-item-upload [data]="item" (onUploaded)="onMultipleUploaded($event)"></zf-item-upload>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="version === '3'">
    <div class="container_multiple version3">
      <div class="content-img-version3">
        <input type="file" (change)="selectFileMultiples($event)"/>
        <ng-container *ngIf="!versionThreeUploaded">
          <svg xmlns="http://www.w3.org/2000/svg" width="63" height="64" viewBox="0 0 63 64">
            <g fill="#3B454F" fill-rule="nonzero">
              <path
                d="M42.656 15.135a1.953 1.953 0 0 1-1.391-.578L31.5 4.795l-9.765 9.762a1.97 1.97 0 1 1-2.785-2.785L30.106.616a1.97 1.97 0 0 1 2.785 0l11.157 11.156a1.97 1.97 0 0 1-1.392 3.363z"/>
              <path
                d="M31.5 36.791a1.97 1.97 0 0 1-1.969-1.969V2.01a1.97 1.97 0 0 1 3.938 0v32.812a1.97 1.97 0 0 1-1.969 1.969z"/>
              <path
                d="M55.781 63.041H7.22A7.225 7.225 0 0 1 0 55.822V41.385a4.599 4.599 0 0 1 4.594-4.594h7.234a4.567 4.567 0 0 1 4.402 3.276l2.814 9.382a.658.658 0 0 0 .628.467h23.656a.658.658 0 0 0 .628-.467l2.814-9.385a4.572 4.572 0 0 1 4.402-3.273h7.234A4.599 4.599 0 0 1 63 41.385v14.437a7.225 7.225 0 0 1-7.219 7.219zM4.594 40.729a.656.656 0 0 0-.657.656v14.437a3.286 3.286 0 0 0 3.282 3.282H55.78a3.286 3.286 0 0 0 3.282-3.282V41.385a.656.656 0 0 0-.657-.656h-7.234a.65.65 0 0 0-.628.467L47.73 50.58a4.628 4.628 0 0 1-4.402 3.274H19.672a4.567 4.567 0 0 1-4.402-3.276l-2.814-9.382a.65.65 0 0 0-.628-.467H4.594z"/>
            </g>
          </svg>
        </ng-container>

        <ng-container *ngIf="versionThreeUploaded">
          <img class="image-loaded" [src]="imageUrl"/>
        </ng-container>

        <h6>Drag and drop file here or Browse</h6>
        <!--      <h5>or</h5>-->
        <!--      <label>Browse for file</label>-->
      </div>
    </div>

    <div class="files-list version3-file">
      <div class="single-file" *ngIf="files.length > 0">
        <zf-item-upload [data]="files[0]" (onUploaded)="onMultipleUploadedVersionThree($event)"></zf-item-upload>
      </div>
    </div>
  </ng-container>

  <!--<button class="btn btn-success" *ngIf="!isUploaded" [disabled]="!selectedFiles" (click)="upload()">Upload</button>-->
  <!--<button class="btn btn-success" *ngIf="isUploaded" disabled><i class="fa fa-circle-o-notch fa-spin"></i></button>-->

  <small>{{ message }}</small>
  <progressbar *ngIf="progress > 0 && progress !== 100" [animate]="true" [value]="progress"
               type="success"></progressbar>
</div>
